import React, { useMemo } from 'react'
import { BaseEditorField } from 'src/editor/shared/entities/base-editor-field'
import { contactFieldLocoKeys } from 'src/shared/constants/contact-field-loco-keys'
import {
  FormFieldInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { FormBaseSubEntity } from './form-base-sub-entity'

interface FormFieldSubEntityProps {
  formEntity: FormInterface
  fieldSubEntity: FormFieldInterface
}

export const FormFieldSubEntity = ({
  formEntity,
  fieldSubEntity,
}: FormFieldSubEntityProps) => {
  const entity = useMemo(
    () => ({
      ...fieldSubEntity,
      ...formEntity.fieldsCommonStyles,
    }),
    [fieldSubEntity, formEntity.fieldsCommonStyles],
  )

  return (
    <FormBaseSubEntity
      title={contactFieldLocoKeys[fieldSubEntity.slug]}
      formEntity={formEntity}
      subEntity={fieldSubEntity}
    >
      <BaseEditorField entity={entity} />
    </FormBaseSubEntity>
  )
}
